<ion-content class="ion-padding-horizontal">
    @if (title) {
        <h1 class="text-title h2">{{ title }}</h1>
    }

    <lib-error-card [errors]="errors()" />

    <div class="ion-margin-vertical">
        <p class="ion-no-margin">
            @if (type === 'register') {
                Your passcode has been sent to your phone number
            } @else if (type === 'reset') {
                Your passcode has been sent to your email
            }
            <span class="text-bold ion-no-margin">
                @if ((clientUserService.user() || proUserService.user()) && type === 'register') {
                    {{ clientUserService.user()?.phone || proUserService.user()?.phone || '' | formatPhoneNumber }}
                } @else if (type === 'reset') {
                    {{ forgotEmail() }}
                }
            </span>
        </p>
    </div>

    <div class="ion-padding-vertical ion-text-center">
        <ngx-otp-input
            class="otp-input"
            (otpChange)="onOTPChange($event)"
            (otpComplete)="onOTPComplete($event)"
            #otpInput
            [options]="otpOptions"
            [status]="otpStatus" />
    </div>

    <p class="ion-text-center text-dark">
        @if (countdownSeconds() > 0) {
            Resend OTP will be available in
            {{ countdownFormatted() }}sec
        } @else if (countdownSeconds() <= 0) {
            <lib-button
                [displayAsInlineText]="true"
                [inlineTextNoTransform]="true"
                (onClick)="resendCode()"
                [disabled]="isResendingCode()">
                Resend OTP
            </lib-button>
        }
    </p>
</ion-content>
<lib-footer>
    <lib-button [expand]="true" (onClick)="onContinue()" [disabled]="!canContinue()">Continue</lib-button>
</lib-footer>
